import React, { useEffect, useState } from "react";
import DatePicker, { registerLocale } from 'react-datepicker'
import { Link } from "react-router-dom";
import ContentHeader from '../../components/ContentHeader'
import Loader from "../../components/Loader";
import Swal from "sweetalert2";
import axios from "axios";
import $ from 'jquery';
import Switch from "react-switch";
import 'datatables.net-bs4';
import 'datatables.net-bs4/css/dataTables.bootstrap4.min.css';
import 'select2';
import 'select2/dist/css/select2.min.css';
import { Tooltip } from 'bootstrap';
import 'react-datepicker/dist/react-datepicker.css'
import es from "date-fns/locale/es";

registerLocale('es', es);

const Prices = () => {
    const [title, setTitle] = useState("Precios");
    const [loading, setLoading] = useState(false);
    const [price_id, setPriceId] = useState(0);
    const [origin_id_edit, setOriginIdEdit] = useState(0);
    const [destination_id_edit, setDestinationIdEdit] = useState(0);
    const [origins, setOrigins] = useState([]);
    const [destinations, setDestinations] = useState([]);
    const [origin_id, setOriginId] = useState(0);
    const [destination_id, setDestinationId] = useState(0);
    const [date, setDate] = useState(new Date());
    const [date_init, setDateInit] = useState('');
    const [date_finish, setDateFinish] = useState('');
    const [prices, setPrices] = useState([]);
    const [price, setPrice] = useState(0);
    const [price_pet, setPricePet] = useState(0);
    const [price_extra, setPriceExtra] = useState(0);
    const [active, setActive] = useState(0);
    const [inactive, setInactive] = useState(0);
    const ENDPOINT = process.env.REACT_APP_URL_ENDPOINT;
    const TITLEALERT = process.env.REACT_APP_TITLE_ALERT;

    useEffect(() => {
        getAll();
        getAllOrigins();
        setTimeout(() => {
            $('.select2').select2({ width: "100%", placeholder: "Seleccione" });
        }, 100);
        // Initialize tooltips
        var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
        tooltipTriggerList.map(function (tooltipTriggerEl) {
            return new Tooltip(tooltipTriggerEl);
        });
    }, []);

    $('#origin_id').on("change", function (e) {
        setOriginId(e.target.value);
        getAllDestinations(e.target.value);
    });

    $('#destination_id').on("change", function (e) {
        setDestinationId(e.target.value);
    });

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        await axios
            .put(ENDPOINT + "update-price/" + price_id, {
                price_id: price_id,
                origin_id: origin_id_edit,
                destination_id: destination_id_edit,
                date_init: date_init,
                date_finish: date_finish,
                price: price,
                price_pet: price_pet,
                price_extra: price_extra
            })
            .then((response) => {
                getAll();
                clearField();
                setLoading(false);
                $("#closemodal").trigger("click");
                Swal.fire({
                    icon: "success",
                    title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                    showConfirmButton: false,
                    timer: 3000,
                    html: '<div class="text-custom-alert">' + response.data.msg + "</div>",
                    showClass: { popup: "animate__animated animate__fadeInDown" },
                    hideClass: { popup: "animate__animated animate__fadeOutUp" },
                });
            })
            .catch(function (error) {
                console.log(error);
                setLoading(true);
                Swal.fire({
                    icon: "error",
                    title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                    showConfirmButton: true,
                    timer: 3000,
                    html: '<div class="text-custom-alert">' + error.response.data.msg + "</div>",
                    showClass: { popup: "animate__animated animate__fadeInDown" },
                    hideClass: { popup: "animate__animated animate__fadeOutUp" },
                });
            });
    };

    const getAllOrigins = async () => {
        const response = await axios.get(ENDPOINT + 'get-all-origins-prices');
        const originsArray = response.data.data.map(function (element) {
            return {
                label: element.name,
                value: element.destination_id,
            };
        })
        setOrigins(originsArray);
    };

    const getAllDestinations = async (origin_id) => {
        setDestinations([]);
        setLoading(true);
        const response = await axios.get(ENDPOINT + 'get-all-destinations-prices/' + origin_id);
        const destinationsArray = response.data.data.map(function (element) {
            return {
                label: element.name,
                value: element.destination_id,
            };
        })
        setDestinations(destinationsArray);
        setLoading(false);
    };

    const getAll = async () => {
        const form = new FormData();
        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, "0");
        const day = date.getDate().toString().padStart(2, "0");
        const dateFormat = year + '-' + month + '-' + day;
        form.append('origin_id', origin_id);
        form.append('destination_id', destination_id);
        form.append('date', dateFormat);
        setLoading(true);
        await axios.post(ENDPOINT + 'get-all-prices', form).then(response => {
            setLoading(false);
            setPrices(response.data.data);
            setActive(response.data.data.filter((e) => e.status === 1).length);
            setInactive(response.data.data.filter((e) => e.status === 0).length);
            var table = $('.main').DataTable();
            table.destroy();
            setTimeout(() => {
                $('.main').DataTable({
                    searching: true,
                    destroy: true,
                    retrieve: true,
                    pageLength: 10,
                    responsive: false,
                    autoWidth: true,
                    paging: true,
                    ordering: true,
                    sortable: true,
                    processing: false,
                    serverSide: false,
                    bInfo: true,
                    language: {
                        "decimal": "",
                        "emptyTable": "",
                        "info": "Mostrando _START_ a _END_ de _TOTAL_ registros",
                        "infoEmpty": "Mostrando registros del 0 al 0 de un total de 0 registros",
                        "infoFiltered": "(filtrado de un total de _MAX_ registros)",
                        "infoPostFix": "",
                        "thousands": ",",
                        "lengthMenu": "Mostrar _MENU_ registros",
                        "loadingRecords": "Cargando...",
                        "processing": "Procesando...",
                        "search": "Buscar:",
                        "paginate": {
                            "first": "<i class='fa-solid fa-circle-chevron-left'></i>",
                            "last": "<i class='fa-solid fa-circle-chevron-right'></i>",
                            "next": "<i class='fas fa-arrow-circle-right'></i>",
                            "previous": "<i class='fas fa-arrow-circle-left'></i>"
                        },
                        "zeroRecords": "No hay registros",
                        "searchPlaceholder": "Buscar...",
                    },
                });
                setLoading(false);
            }, 100);
        }).catch(function (error) {
            setLoading(false);
            Swal.fire({
                icon: 'error',
                title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                showConfirmButton: true,
                html: '<div class="text-custom-alert">' + error.response.data.msg + '</div>',
                showClass: { popup: 'animate__animated animate__fadeInDown' },
                hideClass: { popup: 'animate__animated animate__fadeOutUp' }
            })
        });
    };

    const toggleSwitch = async (val) => {
        setLoading(true);
        await axios
            .get(ENDPOINT + "get-prices-status/" + val)
            .then((response) => {
                getAll();
                setLoading(false);
                Swal.fire({
                    icon: "success",
                    title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                    showConfirmButton: false,
                    timer: 3000,
                    html: '<div class="text-custom-alert">' + response.data.msg + "</div>",
                    showClass: { popup: "animate__animated animate__fadeInDown" },
                    hideClass: { popup: "animate__animated animate__fadeOutUp" },
                });
            })
            .catch(function (error) {
                console.log(error);
                setLoading(false);
                Swal.fire({
                    icon: "error",
                    title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                    showConfirmButton: true,
                    timer: 3000,
                    html: '<div class="text-custom-alert">' + error.response.data.msg + "</div>",
                    showClass: { popup: "animate__animated animate__fadeInDown" },
                    hideClass: { popup: "animate__animated animate__fadeOutUp" },
                });
            });
    };

    const clearField = () => {
        setPriceId(0);
        setOriginIdEdit(0);
        setDestinationIdEdit(0);
        setDateInit('');
        setDateFinish('');
        setPrice(0);
        setPricePet(0);
        setPriceExtra(0);
        setTitle("Editar Precio");
        $('#branch_id').removeClass('select2');
        setTimeout(() => {
            $('#origin_id').addClass('select2');
            $('#destination_id').addClass('select2');
            $('.select2').select2({ width: "100%" });
        }, 100);
    };

    const handleEdit = async (id) => {
        getAllDestinations(0);
        setLoading(true);
        await axios
            .get(ENDPOINT + "get-price/" + id)
            .then((response) => {
                setLoading(false);
                setPriceId(response.data.data.price_id);
                setOriginIdEdit(response.data.data.origin_id);
                setDestinationIdEdit(response.data.data.destination_id);
                setDateInit(response.data.data.date_init);
                setDateFinish(response.data.data.date_finish);
                setPrice(response.data.data.price);
                setPricePet(response.data.data.price_pet);
                setPriceExtra(response.data.data.price_extra);
                setTitle("Editar Precio");
            })
            .catch(function (error) {
                console.log(error);
                setLoading(false);
            });
    };

    const handleDelete = (id, name) => {
        Swal.fire({
            title: `¿Desea eliminar el registro [ ${name} ] ?`,
            text: "No podrá recuperarlo",
            icon: "warning",
            confirmButtonText: "Sí, eliminarlo",
            confirmButtonColor: "#469408",
            showCancelButton: true,
            cancelButtonColor: "#c71c22",
            cancelButtonText: "No",
        }).then((result) => {
            if (result.isConfirmed) {
                setLoading(true);
                axios
                    .delete(ENDPOINT + "delete-price/" + id).then((response) => {
                        getAll();
                        setLoading(false);
                        Swal.fire({
                            icon: "success",
                            title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                            showConfirmButton: false,
                            timer: 3000,
                            html: '<div class="text-custom-alert">' + response.data.msg + "</div>",
                            showClass: { popup: "animate__animated animate__fadeInDown" },
                            hideClass: { popup: "animate__animated animate__fadeOutUp" },
                        });
                    })
                    .catch(function (error) {
                        setLoading(false);
                        Swal.fire({
                            icon: "error",
                            title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                            showConfirmButton: true,
                            timer: 3000,
                            html: '<div class="text-custom-alert">' + error.response.data.msg + "</div>",
                            showClass: { popup: "animate__animated animate__fadeInDown" },
                            hideClass: { popup: "animate__animated animate__fadeOutUp" },
                        });
                    });
            }
        });
    };

    const resetPage = () => {
        window.location.reload();
    };

    const handlePrint = async () => {
        setLoading(true);
        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, "0");
        const day = date.getDate().toString().padStart(2, "0");
        const date_send = year + '-' + month + '-' + day;
        const form = new FormData();
        form.append('origin_id', origin_id);
        form.append('destination_id', destination_id);
        form.append('date', date_send);
        await axios.post(ENDPOINT + 'print-pdf-binnacle', form, { responseType: "blob" })
            .then((response) => {
                const url = window.URL.createObjectURL(response.data);
                window.open(url, '_blank');
                setLoading(false);
            }).catch(function (error) {
                setLoading(false);
                Swal.fire({
                    icon: 'error',
                    title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                    showConfirmButton: true,
                    html: '<div class="text-custom-alert">No hay datos para generar el reporte</div>',
                    showClass: { popup: 'animate__animated animate__fadeInDown' },
                    hideClass: { popup: 'animate__animated animate__fadeOutUp' }
                })
            });

    };

    const formatDate = (dateString) => {
        if (!dateString) return "";
        const date = new Date(dateString);
        date.setMinutes(date.getMinutes() + date.getTimezoneOffset());
        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
    };

    return (
        <div>
            {loading && <Loader />}

            <div className="modal fade" id="modal-default" aria-labelledby="modal-default" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header bg-header-modal">
                            <h4 className="modal-title">{title}</h4>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" ></button>
                        </div>
                        <form id="formulario" onSubmit={handleSubmit}>
                            <div className="modal-body">
                                <div className="row">
                                    <div className="col-12 col-sm-12">
                                        <div className="form-group">
                                            <label htmlFor="origin_id_edit" className="col-form-label col-form-label-sm">
                                                Origen
                                            </label>
                                            <select
                                                className="form-control form-control-sm select2"
                                                id="origin_id_edit"
                                                name="origin_id_edit"
                                            >
                                                {origins.map((item, index) => (
                                                    <option
                                                        selected={item.value === origin_id_edit}
                                                        key={index}
                                                        value={item.value}>
                                                        {item.label}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-12">
                                        <div className="form-group">
                                            <label htmlFor="destination_id_edit" className="col-form-label col-form-label-sm">
                                                Destino
                                            </label>
                                            <select
                                                className="form-control form-control-sm select2"
                                                id="destination_id_edit"
                                                name="destination_id_edit"
                                            >
                                                {destinations.map((item, index) => (
                                                    <option
                                                        selected={item.value === destination_id_edit}
                                                        key={index}
                                                        value={item.value}>
                                                        {item.label}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-4">
                                        <div className="form-group">
                                            <label htmlFor="date_init" className="col-form-label col-form-label-sm">
                                                Fecha Inicial
                                            </label>
                                            <input
                                                type="date"
                                                className={`form-control form-control-sm`}
                                                id="date_init"
                                                name="date_init"
                                                value={date_init}
                                                onChange={(e) => setDateInit(e.target.value)}
                                                required
                                            />
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-4">
                                        <div className="form-group">
                                            <label htmlFor="date_finish" className="col-form-label col-form-label-sm">
                                                Fecha Final
                                            </label>
                                            <input
                                                type="date"
                                                className={`form-control form-control-sm`}
                                                id="date_finish"
                                                name="date_finish"
                                                value={date_finish}
                                                onChange={(e) => setDateFinish(e.target.value)}
                                                required
                                            />
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-4">
                                        <div className="form-group">
                                            <label htmlFor="price" className="col-form-label col-form-label-sm">
                                                Precio
                                            </label>
                                            <input
                                                type="number"
                                                className={`form-control form-control-sm`}
                                                id="price"
                                                name="price"
                                                value={price}
                                                onChange={(e) => setPrice(e.target.value)}
                                                required
                                            />
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-4">
                                        <div className="form-group">
                                            <label htmlFor="price_pet" className="col-form-label col-form-label-sm">
                                                Precio Mascota
                                            </label>
                                            <input
                                                type="number"
                                                className={`form-control form-control-sm`}
                                                id="price_pet"
                                                name="price_pet"
                                                value={price_pet}
                                                onChange={(e) => setPricePet(e.target.value)}
                                                required
                                            />
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-4">
                                        <div className="form-group">
                                            <label htmlFor="price_extra" className="col-form-label col-form-label-sm">
                                                Precio Extra
                                            </label>
                                            <input
                                                type="number"
                                                className={`form-control form-control-sm`}
                                                id="price_extra"
                                                name="price_extra"
                                                value={price_extra}
                                                onChange={(e) => setPriceExtra(e.target.value)}
                                                required
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button
                                    type="submit"
                                    className="btn btn-success">
                                    <i className="fa-regular fa-floppy-disk me-1"></i>
                                    {price_id === 0 ? "Guardar" : "Actualizar"}
                                </button>
                                <button
                                    id="closemodal"
                                    type="button"
                                    className="btn btn-danger"
                                    data-bs-dismiss="modal">
                                    <i className="fa-solid fa-ban me-1"></i> Cancelar
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>

            <div className="container-fluid">
                <ContentHeader
                    title="Módulo de Precios"
                />
            </div>

            <div className="container-fluid">
                <div className="card">
                    <div className="card-header">
                        <div className="indications-header row">
                            <div className="col-md-7">
                                <h4 className="card-title m-0 page-title">
                                    <i className="bi bi-tags me-2"></i> Listado de Precios
                                </h4>
                            </div>
                            <div className="col-md-5" style={{ textAlign: "right" }}>
                                <Link
                                    to="/agregar-precios"
                                    className="btn btn-success btn-sm me-1">
                                    <i className="fas fa-plus-circle me-1"></i> Agregar
                                </Link>
                                <button
                                    onClick={resetPage}
                                    className="btn btn-info btn-sm me-1"
                                    type="button">
                                    <i className="fa fa-refresh me-1"></i> Recargar
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className="card-body">
                        <div className="indications row mb-4">
                            <div className="col-md-2 col-sm-6 mb-2">
                                <div className="form-group">
                                    <label htmlFor="origin_id" className="col-form-label col-form-label-sm">
                                        Origen
                                    </label>
                                    <select
                                        className="form-control form-control-sm select2"
                                        id="origin_id"
                                        name="origin_id"
                                    >
                                        <option selected value="">Seleccione origen</option>
                                        {origins.map((item, index) => (
                                            <option key={index} value={item.value}>{item.label}</option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                            <div className="col-md-2 col-sm-6 mb-2">
                                <div className="form-group">
                                    <label htmlFor="destination_id" className="col-form-label col-form-label-sm">
                                        Destino
                                    </label>
                                    <select
                                        className="form-control form-control-sm select2"
                                        id="destination_id"
                                        name="destination_id"
                                        required
                                    >
                                        <option selected value="">Seleccione destino</option>
                                        {destinations.map((item, index) => (
                                            <option key={index} value={item.value}>{item.label}</option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                            <div className="col-md-2 col-sm-6 mb-2">
                                <div className="form-group">
                                    <label htmlFor="date" className="col-form-label col-form-label-sm">
                                        Fecha
                                    </label>
                                    <DatePicker
                                        showIcon
                                        locale="es"
                                        selected={date}
                                        onChange={(date) => setDate(date)}
                                        /*onCalendarClose={handleCalendarClose}*/
                                        className="form-control form-control-sm"
                                        icon="fa fa-calendar"
                                        required
                                        dateFormat="dd, MMMM, yyyy"
                                    />
                                </div>
                            </div>
                            <div className="col-md-3 col-sm-6 mb-3" style={{ display: "flex", justifyContent: 'start', alignItems: "center" }}>
                                <button
                                    onClick={() => getAll()}
                                    className="btn btn-primary btn-sm me-1 mt-3">
                                    <i className="fa fa-search me-1"></i> Buscar
                                </button>
                                {/*<button
                                    onClick={() => handlePrint()}
                                    className="btn btn-danger btn-sm me-1 mt-3">
                                    <i className="fa-solid fa-file-pdf me-1"></i> Descargar
                                </button>*/}
                            </div>
                            <div className="col-md-3 col-sm-6 mb-3">
                                <div className="form-group">
                                    <table className="table table-bordered">
                                        <thead>
                                            <tr className="text-center">
                                                <td className="indications-table" width="30%" >Total</td>
                                                <td className="indications-table" width="30%" >Activos</td>
                                                <td className="indications-table" width="30%" >Inactivos</td>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td id="TuserT">{active + inactive}</td>
                                                <td id="TuserA">{active}</td>
                                                <td id="TuserI">{inactive}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <table className="table table-hover main table-striped">
                            <thead>
                                <tr>
                                    <th width="8%" className="text-center">ID</th>
                                    <th width="10%" className="text-lef">Origen</th>
                                    <th width="10%" className="text-left">Destino</th>
                                    <th width="10%" className="text-center">Fecha Inicial</th>
                                    <th width="10%" className="text-center">Fecha Final</th>
                                    <th width="10%" className="text-center">Precio</th>
                                    <th width="10%" className="text-center">Precio Mascota</th>
                                    <th width="10%" className="text-center">Precio Extra</th>
                                    <th width="9%" className="text-center">Estatus</th>
                                    <th width="8%" className="text-left">Opciones</th>
                                </tr>
                            </thead>
                            <tbody>
                                {prices.map((item, index) => (
                                    <tr key={index}>
                                        <td className="text-center">
                                            <strong>{item.price_id}</strong>
                                        </td>
                                        <td className="text-left">
                                            {item.origin.name}
                                        </td>
                                        <td className="text-left">
                                            {item.destination.name}
                                        </td>
                                        <td className="text-center">
                                            {formatDate(item.date_init)}
                                        </td>
                                        <td className="text-center">
                                            {formatDate(item.date_finish)}
                                        </td>
                                        <td className="text-center">
                                            {item.price}
                                        </td>
                                        <td className="text-center">
                                            {item.price_pet}
                                        </td>
                                        <td className="text-center">
                                            {item.price_extra}
                                        </td>
                                        <td className="text-center">
                                            <div data-toggle="tooltip" data-placement="top" title="Estado">
                                                <Switch
                                                    checkedIcon={false}
                                                    uncheckedIcon={false}
                                                    checked={item.status === 1 ? true : false}
                                                    onChange={() => toggleSwitch(item.price_id)}
                                                />
                                            </div>
                                        </td>
                                        <td className="text-left">
                                            <div>
                                                <span
                                                    data-bs-toggle="tooltip"
                                                    data-bs-placement="top"
                                                    title="Editar registro">
                                                    <button
                                                        data-bs-toggle="modal"
                                                        data-bs-target="#modal-default"
                                                        className="btn-sm btn btn-warning me-1"
                                                        onClick={() => handleEdit(item.price_id)}
                                                    >
                                                        <i className="fa-solid fa-pen-to-square"></i>
                                                    </button>
                                                </span>
                                                <button
                                                    data-bs-toggle="tooltip"
                                                    data-bs-placement="top"
                                                    title="Eliminar registro"
                                                    className="btn-sm btn btn-danger me-1"
                                                    onClick={() => handleDelete(item.price_id, item.origin.name + ' - ' + item.destination.name)}
                                                >
                                                    <i className="fa-solid fa-trash-can"></i>
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

        </div>
    )
}

export default Prices;